// chart1Type.js
export const CHART1_REQUEST = "CHART1_REQUEST";
export const CHART1_SUCCESS = "CHART1_SUCCESS";
export const CHART1_FAILURE = "CHART1_FAILURE";
